import { render, staticRenderFns } from "./menuitem.vue?vue&type=template&id=7e37b4e0&"
import script from "./menuitem.vue?vue&type=script&lang=js&"
export * from "./menuitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e37b4e0')) {
      api.createRecord('7e37b4e0', component.options)
    } else {
      api.reload('7e37b4e0', component.options)
    }
    module.hot.accept("./menuitem.vue?vue&type=template&id=7e37b4e0&", function () {
      api.rerender('7e37b4e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/scripts/components/organisms/Menu/menuitem.vue"
export default component.exports